import { FC, useEffect } from 'react';
import EditorVideo from 'lowcode/components/EditorVideo';
import styled from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import getLocal from '@/app/utils/getLocal';
import { BannerIcon } from '@/components/XPower/svg';

const Banner: FC = () => {
    const { locale } = getLocal();
    const { t } = useLang(`xcode.banner`);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneA = AniContainer.create({
                asyncFromTo: [
                    [`.${styled.Banner} .bg .mark`, { opacity: 0.4 }, { opacity: 0.7 }, 1],
                    [`.${styled.Banner} .first_text`, { y: 0, opacity: 1 }, { y: -200, opacity: 0 }, 1],
                ],
                triggerElement: `.${styled.Banner} .first_text`,
                triggerHook: 1,
                offset: '10%',
                duration: '50%',
            });

            const sceneB = AniContainer.create({
                asyncFromTo: [
                    [`.${styled.Banner} .second_text .section1`, { opacity: 0.3 }, { opacity: 1 }, 1],
                    [`.${styled.Banner} .second_text .section1`, { opacity: 1 }, { opacity: 1 }, 1],
                    [`.${styled.Banner} .second_text .section1`, { opacity: 1 }, { opacity: 0.3 }, 1],

                    [`.${styled.Banner} .second_text .section2`, { opacity: 0.3 }, { opacity: 1 }, 1],
                    [`.${styled.Banner} .second_text .section2`, { opacity: 1 }, { opacity: 1 }, 1],
                    [`.${styled.Banner} .second_text .section2`, { opacity: 1 }, { opacity: 0.3 }, 1],

                    [`.${styled.Banner} .second_text .section3`, { opacity: 0.3 }, { opacity: 1 }, 1],
                    [`.${styled.Banner} .second_text .section3`, { opacity: 1 }, { opacity: 1 }, 1],
                    [`.${styled.Banner} .second_text .section3`, { opacity: 1 }, { opacity: 0.3 }, 1],

                    [`.${styled.Banner} .second_text .section4`, { opacity: 0.3 }, { opacity: 1 }, 1],
                    [`.${styled.Banner} .second_text .section4`, { opacity: 1 }, { opacity: 1 }, 1],
                    [`.${styled.Banner} .second_text .section4`, { opacity: 1 }, { opacity: 0.3 }, 1],

                    [`.${styled.Banner} .second_text .section5`, { opacity: 0.3 }, { opacity: 1 }, 1],
                    [`.${styled.Banner} .second_text .section5`, { opacity: 1 }, { opacity: 1 }, 1],
                    [`.${styled.Banner} .second_text .section5`, { opacity: 1 }, { opacity: 0.3 }, 1],

                    [`.${styled.Banner} .second_text .section6`, { opacity: 0.3 }, { opacity: 1 }, 1],
                    [`.${styled.Banner} .second_text .section6`, { opacity: 1 }, { opacity: 1 }, 1],
                    [`.${styled.Banner} .second_text .section6`, { opacity: 1 }, { opacity: 0.3 }, 1],

                    [`.${styled.Banner} .second_text .section7`, { opacity: 0.3 }, { opacity: 1 }, 1],
                    [`.${styled.Banner} .second_text .section7`, { opacity: 1 }, { opacity: 1 }, 1],
                    // [`.${styled.Banner}`, { opacity: 1 }, { opacity: 0 }, 1],
                ],
                asyncTimeLine: [0, 1, 1, 1, 2, 2, 2, 3, 3, 3, 4, 4, 4, 5, 5, 5, 6, 6, 6, 7],
                triggerElement: `.${styled.Banner} .second_text`,
                triggerHook: 1,
                offset: '20%',
                duration: '120%',
            });
            AniContainer.scrollHandle(); //执行一次初始化
            return () => AniContainer.removeScene([sceneA, sceneB]);
        }
    }, []);

    return (
        <div className={styled.Banner}>
            <div className="bg">
                <div className="mark"></div>
                <EditorVideo className="video" autoPlay loop src="https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1717121518286/KV_H.264.mp4" />
            </div>
            <div className="first_text">
                <BannerIcon className="title" />
                <p className="subtitle">{t('subtitle')}</p>
                <p className="desc">{t('desc')}</p>
            </div>
            <div className="second_text">
                <p className="section">
                    <span className="section1">{t('section1')}</span>
                    <span className="section2">&nbsp;{t('section2')}</span>
                    <span className="section3">&nbsp;{t('section3')}</span>
                </p>
                <p className="section">
                    <span className="section4">&nbsp;{t('section4')}</span>
                    <span className="section5">&nbsp;{t('section5')}</span>
                    <span className="section6">&nbsp;{t('section6')}</span>
                    <span className="section7">&nbsp;{t('section7')}</span>
                </p>
            </div>
        </div>
    );
};

export default Banner;
